// Login / Forgotten password toggle
$('.js-toggle-targets').on('click', function (e) {
	e.preventDefault();
	const $this = $(this);
	const targetString = $this.attr('href');

	$(targetString).show();

	$($this.data('hide')).hide();
});

const $showOrdersButton = $('.js-show-orders-content');
const showSection = $showOrdersButton.data('show');
const hideSection = $showOrdersButton.data('hide');

// If we are on other page than /account
// Load the page and show the hidden content using the #ID in the browser URL
if (window.location.href.indexOf(showSection) > -1) {
	$(showSection).show();
	$(hideSection).hide();

	$showOrdersButton.parent().addClass('is-active').siblings().removeClass('is-active');

	$('html').animate({ scrollTop: 0 }, '0');
}

$showOrdersButton.on('click', function (e) {
	// If we are currently on /account page
	// Show the hidden content
	if (window.location.href.substring(window.location.href.lastIndexOf('/') + 1) == 'account') {
		e.preventDefault();

		history.pushState(1, 'orders', targetString);

		const $this = $(this);
		const targetString = $this.data('show');
		const hideString = $this.data('hide');

		$(targetString).show();
		$(hideString).hide();

		$this.parent().addClass('is-active').siblings().removeClass('is-active');
	}
});

// Collection sortBy
$('#sortBy').on('change', function () {
	Shopify.queryParams = {};
	const $this = $(this);
	const thisVal = $this.val();

	if (location.search) {
		const getArgumentsArray = location.search.substr(1).split('&');
		getArgumentsArray.map(function (ele) {
			const eleArray = ele.split('=');
			Shopify.queryParams[decodeURIComponent(eleArray[0])] = decodeURIComponent(eleArray[1]);
		});
	}

	Shopify.queryParams.sort_by = thisVal;
	location.search = jQuery.param(Shopify.queryParams);
});

// Product price update
$('.product-single__variants').on('change', function () {
	const $this = $(this);
	const $option = $this.find('option:selected');
	const $btnSubmit = $this.closest('form').find('input[type="submit"], button[type="submit"]');
	const thisPrice = $this.find('option:selected').data('price');

	$('.product__price').html(thisPrice);

	if ($option.is(':disabled')) {
		$btnSubmit.html(Shopify.theme.locale.products.product.sold_out).prop('disabled', true);
	} else {
		$btnSubmit.html(Shopify.theme.locale.products.product.add_to_cart).prop('disabled', false);
	}
});

// Address province option
$('select[name="address[country]"]').each(function () {
	const $this = $(this);
	const thisID = $this.attr('id');
	const province = $this.closest('form').find('select[name="address[province]"]');
	const provinceID = province.attr('id');
	const provinceHolderID = province.closest('.form__row').attr('id');
	new Shopify.CountryProvinceSelector(thisID, provinceID, {
		hideElement: provinceHolderID,
	});
});
